import React from "react";
import { useSelector } from "react-redux";
import { 
    selectPower,
    selectKSpringOne,
    selectPresetSpringOne,
    selectKSpringTwo,
    selectPositionSpringTwo,
    selectShowIdealCurve,
    selectShowSpringCurve,
    selectDoubleSpring,
    selectDisplacement,
    selectSetting1Offset,
    selectSetting2Offset,
    selectOverride,
} from "../drawingBoard/drawingBoardSlice";
import { 
    kwFromBarAndLpm, 
    barFromKwAndLpmIdeal,
    barFromKAndPresetAndLpmLinear,
    barFromTwoSpringSystem,
    barFromPresetKsAndPositoins,
} from "./formulae";

const Graphic = () => {
    const power = useSelector(selectPower);
    const kSpringOne = useSelector(selectKSpringOne);
    const presetSpringOne = useSelector(selectPresetSpringOne);
    const kSpringTwo = useSelector(selectKSpringTwo);
    const positionSpringTwo = useSelector(selectPositionSpringTwo);
    const showIdealCurve = useSelector(selectShowIdealCurve);
    const showSpringCurve = useSelector(selectShowSpringCurve);
    const doubleSpring = useSelector(selectDoubleSpring);
    const displacement = useSelector(selectDisplacement);
    const setting1Offset = useSelector(selectSetting1Offset);
    const setting2Offset = useSelector(selectSetting2Offset);
    const override = useSelector(selectOverride);
    const resolutionLpm = 1;
    const lpmMin = 10;
    const lpmMax = 100;
    const barToY = (bar) => {
        return -bar*(10000/300); 
    }
    const lpmToX = (lpm) => {
        return lpm*100;
    }
    const kwToY = (kw) => {
        return -kw*333.33;
    }
    const createPressureCurve = (barCurveFunc, ...theArgs) => {
        let resultAttribute = "";
        for (let i = lpmMin; i <= lpmMax; i+= resolutionLpm){
            resultAttribute += `${lpmToX(i)},${barToY(barCurveFunc(...theArgs,i))} `
        }
        return resultAttribute;
    }

    const createPowerCurve = (barCurveFunc, ...theArgs) => {
        let resultAttribute = "";
        for (let i = lpmMin; i <= lpmMax; i+= resolutionLpm){
            resultAttribute += `${lpmToX(i)},${kwToY(kwFromBarAndLpm(barCurveFunc(...theArgs,i),i))} `
        }
        return resultAttribute;
    }

    const DisplacementArrow = () => {
        const displacementX = displacement*100;
        return (<g>
            <path
                d={`M${displacementX},-10000 l150,-150 l0,-250 l-300,0 l0,250 Z`}
                stroke="blue"
                strokeWidth={40}
                fill="none"
            />
            <line 
                x1={`${displacementX}`}
                y1={-10000}
                x2={`${displacementX}`}
                y2={0}
                strokeWidth={10}
                stroke="blue"
            />
        </g>);
    }

    return(
        <g>
            {showIdealCurve ? 
                <g>
                    <polyline 
                        points={createPressureCurve(barFromKwAndLpmIdeal, power)}
                        fill="none"
                        stroke="black"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={createPowerCurve(barFromKwAndLpmIdeal, power)}
                        fill="none"
                        stroke="red"
                        strokeWidth={30}
                    />
                </g>
            : null}
            {showSpringCurve && !doubleSpring ? 
                <g>
                    <polyline 
                        points={
                            createPressureCurve(
                                barFromKAndPresetAndLpmLinear, kSpringOne, presetSpringOne
                            )
                        }
                        fill="none"
                        stroke="green"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={
                            createPowerCurve(
                                barFromKAndPresetAndLpmLinear, kSpringOne, presetSpringOne
                            )
                        }
                        fill="none"
                        stroke="magenta"
                        strokeWidth={30}
                    />
                </g>
            : null}
            {showSpringCurve && doubleSpring ? 
                <g>
                    <polyline 
                        points={
                            createPressureCurve(
                                barFromPresetKsAndPositoins, 
                                kSpringOne, (presetSpringOne - override), kSpringTwo, setting1Offset, setting2Offset
                            )
                        }
                        fill="none"
                        stroke="green"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={
                            createPowerCurve(
                                barFromPresetKsAndPositoins, 
                                kSpringOne, (presetSpringOne - override), kSpringTwo, setting1Offset, setting2Offset
                            )
                        }
                        fill="none"
                        stroke="magenta"
                        strokeWidth={30}
                    />
                </g>
            : null}
            <DisplacementArrow />
        </g>
    );
};

export default Graphic;
